import {
  HStack,
  PanelShell,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { Box } from '@chakra-ui/react';
import FlashIconSVG from '../CustomSVGs/FlashIconSVG';
import { SurveyDisplay } from '../UserDashboard/SurveyDisplay';
import { JournalsDisplay } from '../UserDashboard/JournalsDisplay';

export const PatientLogs = () => {
  return (
    <VStack mx={6} mb={12} alignItems={'stretch'}>
      <HStack alignItems={'center'} mb={6}>
        <FlashIconSVG />
        <Text color={'secondary.200'} fontSize={'md'} fontWeight={'normal'} ml={1}>
          Patient Logs
        </Text>
      </HStack>

      <HStack alignItems={'stretch'} gap={6}>
        <Box flex={1} minW={0}>
          <PanelShell h={'100%'} bg={'cloud.200'}>
            <SurveyDisplay />
          </PanelShell>
        </Box>

        <Box flex={1} minW={0}>
          <PanelShell h={'100%'} bg={'cloud.200'}>
            <JournalsDisplay />
          </PanelShell>
        </Box>
      </HStack>
    </VStack>
  );
};
